import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { api } from "@/lib/api";

export default function News() {
  const [news, setNews] = useState([]);
  const [active, setActive] = useState(null);

  useEffect(() => {
    api.get("/news").then((r) => setNews(r.data)).catch(() => {});
  }, []);

  const fmt = (d) => new Date(d).toLocaleDateString("fr-BE", { day: "numeric", month: "long", year: "numeric" });

  return (
    <div>
      <section className="bg-gradient-to-b from-sky-50 to-white py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <span className="text-xs font-bold uppercase tracking-[0.2em] text-sky-500">Actualites</span>
          <h1 className="font-heading font-black text-4xl sm:text-5xl lg:text-6xl text-slate-900 mt-2">
            Le blog Kwarizmix
          </h1>
          <p className="mt-4 text-lg text-slate-600 max-w-2xl">
            Nouveautés, offres et actualités du numérique éducatif.
          </p>
        </div>
      </section>

      <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid md:grid-cols-3 gap-6">
          {news.map((n, i) => (
            <motion.button
              key={n.id}
              onClick={() => setActive(n)}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: (i % 3) * 0.08 }}
              className="text-left bg-white rounded-3xl border border-slate-100 shadow-sm overflow-hidden hover:-translate-y-1 hover:shadow-lg transition-[transform,box-shadow]"
              data-testid={`news-card-${n.id}`}
            >
              <img src={n.image} alt={n.title} className="w-full h-48 object-cover" />
              <div className="p-6">
                <div className="flex items-center gap-2 mb-2">
                  <span className="text-xs font-bold uppercase tracking-wide text-amber-600">{n.category}</span>
                  <span className="text-xs text-slate-400">· {fmt(n.date)}</span>
                </div>
                <h3 className="font-heading font-extrabold text-lg text-slate-900 mb-2">{n.title}</h3>
                <p className="text-sm text-slate-500 line-clamp-3">{n.excerpt}</p>
              </div>
            </motion.button>
          ))}
        </div>
      </section>

      <Dialog open={!!active} onOpenChange={(o) => !o && setActive(null)}>
        <DialogContent className="rounded-3xl max-w-2xl max-h-[90vh] overflow-y-auto">
          {active && (
            <>
              <img src={active.image} alt={active.title} className="w-full h-56 object-cover rounded-2xl" />
              <DialogHeader>
                <span className="text-xs font-bold uppercase tracking-wide text-amber-600">
                  {active.category} · {fmt(active.date)}
                </span>
                <DialogTitle className="font-heading text-2xl">{active.title}</DialogTitle>
              </DialogHeader>
              <p className="text-slate-600 leading-relaxed">{active.content}</p>
            </>
          )}
        </DialogContent>
      </Dialog>
    </div>
  );
}
